<!-- Add Comment -->
<div *ngIf="!isEditMode && !comment" class="row mt-2">
    <div class="col-12 text-right float-sm-right">
    <button type="button" class="btn btn-secondary add-button" (click)="addComment()"><i class="fas fa-plus"></i> Add
        Comment</button>
    </div>
</div>
<!-- Display Comment -->
<div *ngIf="!isEditMode && comment" class="card">
    <div [ngClass]="isMyComment ? 'my-comment-header' : ''" class="card-header d-flex flex-row align-items-center justify-content-between">
        <div class="d-flex flex-row align-items-center">
            <span class="mr-4">{{comment.commenter}}</span>
            <div class="d-flex flex-row align-items-center mr-4">
                <span *ngIf="comment.historic==true" class="badge text-light mr-1 obs-comment-previouscomment">
                    {{historicLabel}}
                </span>
                <span class="badge text-light mr-1 obs-comment-{{getCommentClass(comment)}}">{{commentState(comment)}}</span>
            </div>
            <div *ngIf="!isReadOnly && !comment?.historic && comment.userId==evalUser?.UserID" class="d-flex flex-row">
                <button type="button" (click)="openComment(comment)" ngbTooltip="Edit comment"
                    class="btn btn-sm btn-link mr-3 edit-button"><i class="far fa-edit"></i></button>
                <button type="button"
                    *ngIf="comment.commentState == CommentState.DRAFT" ngbTooltip="Publish comment"
                    (click)="publishComment(comment)" class="btn btn-sm btn-link mr-3 publish-button"><i
                    class="far fa-check-square"></i></button>
                <button type="button"
                    *ngIf="comment.commentState == CommentState.DRAFT" ngbTooltip="Delete comment"
                    (click)="deleteComment(comment)" class="btn btn-sm btn-link delete-button"><i
                    class="far fa-trash-alt"></i></button>
            </div>
        </div>
        <div>
            <span>{{comment.created | date: "M/d/yyyy hh:mm:ss a"}}</span>
        </div>
    </div>

    <div class="card-body" >
        <div class="mb-2" *ngIf="comment.comment" [innerHTML]="sanitizedCommentText"></div>
        <div class="btn-group m-1" role="group" *ngFor="let file of comment.attachments" [permissionsAll]="[PermissionTypes.FILE_ATTACHMENTS]">
          <button  type="button" class="btn btn-info" (click)="viewAttachement(file)" >
            <i class="fas fa-paperclip text-primary"></i> {{file.fileName}} <span class="badge badge-primary" >{{file.uploadDate | date}}</span>
          </button>
          <button type="button" class="btn btn-info" *ngIf="isMyComment && !isReadOnly" (click)="deleteAttachement(file)"> <i class="fas fa-trash-alt" style="color: #ba1717;"></i></button>
        </div>
    </div>
</div>
<!-- Edit Comment -->
<app-observation-comment-form *ngIf="isEditMode"
    [observationSummary]="observationSummary"
    [comment]="comment"
    (commentChange)="setComment($event)"
    [observationType]="observationType"
    [observationId]="observationSummary?.observationId"
    [defaultLookupValue]="comment?.lookupValue ?? defaultLookupValue"
    [hideLookup]="hideFilter"
    [attachmentLabel]="attachmentLabel"
    (onClose)="onClose()"
    [commentFiles]="comment?.attachments"
>
</app-observation-comment-form>

